'use strict';

var _ = require('lodash');
var recommendedFareTooltipTemplate = _.template(require('../templates/fare-tooltip.html'));
var recommendedFareTooltipTemplateWithSharedFbc = _.template(require('../templates/fare-tooltip-shared-fbc.html'));
var fbcToolTipTemplate = _.template(require('../templates/tactical-fbc-tooltip.html'));
var entryLevelFbcToolTipTemplate = _.template(require('../templates/tactical-entry-level-fbc-tooltip.html'));
var fareBrandDescriptionToolTipTemplate = _.template(require('../templates/fare-brand-description-tooltip.html'));
var normalizedTotalFareToolTipTemplate = _.template(require('../templates/normalized-total-fare-tooltip.html'));
var webFareToolTipTemplate = _.template(require('../templates/web-fare-tooltip.html'));
var recommendationStatusToolTipTemplate = _.template(require('../templates/recommendation-status-tooltip.html'));
var FaresOptimizerFareTooltipService = function FaresOptimizerFareTooltipService($filter, faresOptimizerConstants, faresOptimizerDataTransformerService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var TOOLTIP_FIELDS = [{
    label: 'YQ',
    fieldName: 'yq'
  }, {
    label: 'YR',
    fieldName: 'yr'
  }, {
    label: 'Airport Tax',
    fieldName: 'airportTax'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'q'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'qMisc'
  }];
  var COMPETITOR_TOOLTIP_FIELDS = [{
    label: 'Base Fare',
    fieldName: 'compBaseFare'
  }, {
    label: 'YQ',
    fieldName: 'compYq'
  }, {
    label: 'YR',
    fieldName: 'compYr'
  }, {
    label: 'Airport Tax',
    fieldName: 'compAirportTax'
  }, {
    label: 'Variable Tax',
    fieldName: 'compVariable'
  }, {
    label: 'Fuel Surcharge',
    fieldName: 'compQ'
  }, {
    label: 'Cat12 Surcharges',
    fieldName: 'compQMisc'
  }];
  var DEFAULT_BENCHMARK_FARE_COMPONENT = '1111111';
  var getFareComponents = function getFareComponents(row, type) {
    var TOOLTIP_FIELDS_1 = TOOLTIP_FIELDS.slice();
    var benchmarkFareComponentFieldNames = getBenchmarkFareComponentFieldNames(row, type);
    if (type === 'effective') {
      TOOLTIP_FIELDS_1.splice(0, 0, {
        label: 'Base Fare',
        fieldName: 'effectiveBaseFare'
      });
      TOOLTIP_FIELDS_1.splice(4, 0, {
        label: 'Variable Tax',
        fieldName: 'effectiveVariable'
      });
    } else if (type === 'displayComp') {
      TOOLTIP_FIELDS_1 = COMPETITOR_TOOLTIP_FIELDS.slice();
    } else if (type === 'webfare') {
      TOOLTIP_FIELDS_1.splice(3, 2); // remove 'q' and 'qMisc'
      TOOLTIP_FIELDS_1.splice(0, 0, {
        label: 'Base Fare',
        fieldName: 'baseFare'
      });
      TOOLTIP_FIELDS_1.splice(4, 0, {
        label: 'Variable Tax',
        fieldName: 'variable'
      });
    } else {
      TOOLTIP_FIELDS_1.splice(0, 0, {
        label: 'Base Fare',
        fieldName: 'recommendedFareBase'
      });
      TOOLTIP_FIELDS_1.splice(4, 0, {
        label: 'Variable Tax',
        fieldName: 'recommendedVariable'
      });
    }
    return getMappedToolTipFields(TOOLTIP_FIELDS_1, benchmarkFareComponentFieldNames, row);
  };
  function getMappedToolTipFields(tooltipFields, benchmarkFareComponentFieldNames, row) {
    return _.map(tooltipFields, function (tooltipField) {
      return {
        included: benchmarkFareComponentFieldNames.indexOf(tooltipField.fieldName) > -1,
        label: tooltipField.label,
        value: rmNumberFormat(row[tooltipField.fieldName], 'NUMBER_NO_DECIMAL')
      };
    });
  }
  function getRecommendedFareTooltipData(row) {
    return {
      fbc: row.fbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareBrand: getFareBrandForToolTip(row.fareBrand),
      fareComponents: getFareComponents(row, 'recommended'),
      fareTotal: rmNumberFormat(row.recommendedFareTotal, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: true
    };
  }
  function getEffectiveFareTooltipData(row) {
    return {
      fbc: row.fbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareBrand: getFareBrandForToolTip(row.fareBrand),
      fareComponents: getFareComponents(row, 'effective'),
      fareTotal: rmNumberFormat(row.effectiveTotalFare, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: true
    };
  }
  function getCompetitorFareTooltipData(row) {
    return {
      fbc: row.compMarketFbc,
      recommendationId: row.fareRecommendationRecordKey,
      fareComponents: getFareComponents(row, 'displayComp'),
      fareTotal: rmNumberFormat(row.compFare, 'NUMBER_NO_DECIMAL'),
      isShowRecommendationId: false
    };
  }
  function getWebFareTooltipData(row) {
    return {
      fareComponents: getFareComponents(row, 'webfare'),
      fareTotal: rmNumberFormat(row.totalFare, 'NUMBER_NO_DECIMAL')
    };
  }
  function getWebFareTooltipContent(tooltipData) {
    return webFareToolTipTemplate(tooltipData);
  }
  function getFareBrandForToolTip(fareBrand) {
    if (_.isNil(fareBrand) || fareBrand === faresOptimizerConstants.EN_DASH) {
      return '';
    }
    return fareBrand.fareBrand.bold() + ' : ' + fareBrand.description;
  }
  function getFareBrandDescriptionToolTipData(row, isHost) {
    var fareBrand = isHost ? row.fareBrand : row.compFareBrand;
    return {
      title: 'Fare Brand Description',
      description: getFareBrandDescription(fareBrand)
    };
  }
  function getFareBrandDescription(fareBrand) {
    if (_.isNil(fareBrand)) {
      return undefined;
    }
    return fareBrand.description;
  }
  function renderFareBrandDescriptionToolTip(tooltipData) {
    return fareBrandDescriptionToolTipTemplate(tooltipData);
  }
  function getHostFareBrandDescriptionContent(row) {
    var tooltipData = getFareBrandDescriptionToolTipData(row, true);
    return renderFareBrandDescriptionToolTip(tooltipData);
  }
  function getCompFareBrandDescriptionContent(row) {
    var tooltipData = getFareBrandDescriptionToolTipData(row, false);
    return renderFareBrandDescriptionToolTip(tooltipData);
  }
  function shouldRenderHostFareBrandDescriptionToolTip(row) {
    return !(_.isNil(row.fareBrand) || _.isNil(row.fareBrand.description));
  }
  function shouldRenderCompFareBrandDescriptionToolTip(row) {
    return !(_.isNil(row.compFareBrand) || _.isNil(row.compFareBrand.description));
  }
  function shouldRenderNormalizedTotalFareTooltip(row) {
    return !row.isCompetitor;
  }
  function getNormalizedTotalFareTooltipData(row) {
    return {
      label: 'Normalized',
      value: rmNumberFormat(row.normalizedTotalFare, 'NUMBER_NO_DECIMAL')
    };
  }
  function renderNormalizedTotalFareTooltip(tooltipData) {
    return normalizedTotalFareToolTipTemplate(tooltipData);
  }
  function getNormalizedTotalFareTooltipContent(row) {
    var tooltipData = getNormalizedTotalFareTooltipData(row);
    return renderNormalizedTotalFareTooltip(tooltipData);
  }
  var getBenchmarkFareComponentFieldNames = function getBenchmarkFareComponentFieldNames(row, type) {
    var benchmarkFareComponentCharArray = getBenchmarkFareComponent(row).split('');
    var benchmarkFareComponents = [];
    if (type === 'displayComp') {
      return getCompetitorBenchmarkFareComponents(benchmarkFareComponentCharArray);
    } else if (type === 'effective') {
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[0], 'effectiveBaseFare');
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[5], 'effectiveVariable');
    } else if (type === 'webfare') {
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[0], 'baseFare');
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[5], 'variable');
    } else {
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[0], 'recommendedFareBase');
      benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[5], 'recommendedVariable');
    }
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[1], 'yq');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[2], 'yr');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[3], 'q');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[4], 'airportTax');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[6], 'qMisc');
    return benchmarkFareComponents;
  };
  function getCompetitorBenchmarkFareComponents(benchmarkFareComponentCharArray) {
    var benchmarkFareComponents = [];
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[0], 'compBaseFare');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[1], 'compYq');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[2], 'compYr');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[3], 'compQ');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[4], 'compAirportTax');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[5], 'compVariable');
    benchmarkFareComponents = pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentCharArray[6], 'compQMisc');
    return benchmarkFareComponents;
  }
  var pushFieldNameIntoFareComponents = function pushFieldNameIntoFareComponents(benchmarkFareComponents, benchmarkFareComponentChar, fieldName) {
    if (benchmarkFareComponentChar === '1') {
      benchmarkFareComponents.push(fieldName);
    }
    return benchmarkFareComponents;
  };
  var getBenchmarkFareComponent = function getBenchmarkFareComponent(row) {
    return !_.isNil(row.benchmarkFareComponent) ? row.benchmarkFareComponent : DEFAULT_BENCHMARK_FARE_COMPONENT;
  };
  function getRecommendedFareTooltipContent(row) {
    var tooltipData = getRecommendedFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getEffectiveFareTooltipContent(row) {
    var tooltipData = getEffectiveFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function getCompetitorFareTooltipContent(row) {
    var tooltipData = getCompetitorFareTooltipData(row);
    return renderFareTooltip(tooltipData);
  }
  function renderFareTooltip(tooltipData) {
    return recommendedFareTooltipTemplate(tooltipData);
  }
  function renderFareTooltipWithSharedFbc(tooltipData) {
    return recommendedFareTooltipTemplateWithSharedFbc(tooltipData);
  }
  function extractFbcPattern(fbc) {
    return fbc && fbc.length > 0 ? '*' + fbc.substring(1) : '';
  }
  function getStrategyText(businessRule) {
    var strategyText = businessRule.strategy === 'UNDERCUT' ? businessRule.strategy + ' -' + businessRule.amount : businessRule.strategy + ' +' + businessRule.amount;
    if (businessRule.percentageIndicator) {
      strategyText = strategyText + '%';
    }
    return strategyText;
  }
  function getBusinessRuleData(businessRule) {
    var businessRuleTooltip = ' / ';
    if (businessRule.strategy === 'MATCH') {
      return businessRuleTooltip + businessRule.strategy;
    } else {
      return businessRuleTooltip + getStrategyText(businessRule);
    }
  }
  function getBusinessRuleInfo(row) {
    return !_.isEmpty(row.businessRule) ? getBusinessRuleData(row.businessRule) : '';
  }
  function getFbcHeader(row) {
    var fbcHeader = row.fbc;
    fbcHeader = fbcHeader + getBusinessRuleInfo(row);
    return fbcHeader;
  }
  function getEntryLevelFbcHeader(row) {
    if (isEntryLevelRbdMethod(row)) {
      return extractFbcPattern(row.fbc) + getBusinessRuleInfo(row);
    }
    return getHeaderForNonEntryLevelRbdMethod(row);
  }
  function isEntryLevelRbdMethod(row) {
    return _.isEmpty(row.inventoryAssignmentMethod) || faresOptimizerConstants.INVENTORY_ASSIGNMENT_METHOD.ENTRY_LEVEL_RBD === row.inventoryAssignmentMethod;
  }
  function getHeaderForNonEntryLevelRbdMethod(row) {
    if (_.isEmpty(row.businessRule)) {
      return extractFbcPattern(row.fbc);
    }
    return row.fbc + getBusinessRuleInfo(row);
  }
  function getFbcLevelToolTipData(row) {
    var fbcPatternList = _.map(row.sharedEntryLevelFbcList, extractFbcPattern);
    return {
      fbcHeader: getFbcHeader(row),
      ladderList: fbcPatternList,
      actionCode: row.actionCode,
      category: row.category,
      isSharedFbc: row.isSharedFbc,
      effectiveDate: rmMomentFormat(row.effectiveDate, 'DATE_USER_SETTINGS'),
      discontinueDate: rmMomentFormat(row.discontinueDate, 'DATE_USER_SETTINGS')
    };
  }
  function getEntryLevelFbcToolTipData(row) {
    var fbcPatternList = _.map(row.allSharedEntryLevelFbcList, extractFbcPattern);
    return {
      fbcHeader: getEntryLevelFbcHeader(row),
      ladderList: fbcPatternList,
      actionCode: row.actionCode,
      isSharedFbc: row.isSharedFbc || row.hasSharedFbc,
      effectiveDate: rmMomentFormat(row.effectiveDate, 'DATE_USER_SETTINGS'),
      discontinueDate: rmMomentFormat(row.discontinueDate, 'DATE_USER_SETTINGS'),
      recommendationReasons: getRecommendationReasons(row.ladderRemarks)
    };
  }
  var getFbcToolTip = function getFbcToolTip(row) {
    var toolTipData = getFbcLevelToolTipData(row);
    return renderFbcToolTip(toolTipData);
  };
  var getEntryLevelFbcToolTip = function getEntryLevelFbcToolTip(row) {
    var toolTipData = getEntryLevelFbcToolTipData(row);
    return renderEntryLevelFbcToolTip(toolTipData);
  };
  var getRecommendationReasons = function getRecommendationReasons(ladderRemarks) {
    var recommendationReasons = [];
    if (!_.isUndefined(ladderRemarks) && !_.isUndefined(ladderRemarks.recommendationReasons)) {
      _.forEach(ladderRemarks.recommendationReasons, function (value, key) {
        recommendationReasons.push(_.replace(key, /_/g, ' '));
      });
    }
    return recommendationReasons;
  };
  var renderFbcToolTip = function renderFbcToolTip(toolTipData) {
    return fbcToolTipTemplate(toolTipData);
  };
  var renderEntryLevelFbcToolTip = function renderEntryLevelFbcToolTip(toolTipData) {
    return entryLevelFbcToolTipTemplate(toolTipData);
  };
  var shouldRenderFbcToolTip = function shouldRenderFbcToolTip(row, isGrouped) {
    if (_.includes(['N', 'X'], row.actionCode) || isGrouped) {
      return true;
    }
    return row.isEntryLevel || row.isSharedFbc || !_.isEmpty(row.businessRule);
  };
  var shouldRenderCompFareToolTip = function shouldRenderCompFareToolTip(row) {
    return !_.isNil(row) && !_.isNil(row.compMarketFbc);
  };
  var getRecommendedFareTooltipDataWithFbc = function getRecommendedFareTooltipDataWithFbc(row) {
    return _.merge({
      isSharedFbc: row.isSharedFbc,
      hasLinkedFbc: row.hasLinkedFbc,
      linkedFbcs: row.linkedFbcs,
      actionCode: row.actionCode,
      category: row.category
    }, getRecommendedFareTooltipData(row), getFbcLevelToolTipData(row));
  };
  var getEffectiveFareTooltipDataWithFbc = function getEffectiveFareTooltipDataWithFbc(row) {
    return _.merge({
      isSharedFbc: row.isSharedFbc,
      hasLinkedFbc: row.hasLinkedFbc,
      linkedFbcs: row.linkedFbcs,
      actionCode: row.actionCode,
      category: row.category
    }, getEffectiveFareTooltipData(row), getFbcLevelToolTipData(row));
  };
  var getRecommendationStatusToolTipContent = function getRecommendationStatusToolTipContent(row) {
    var toolTipData = getRecommendationStatusToolTipData(row);
    return renderRecommendationStatusToolTip(toolTipData);
  };
  function getRecommendationStatusToolTipData(row) {
    return {
      isAutoApprovable: row.isAutoApprovable,
      recommendationStopReasons: getAutoApproveableStopReasons(row.ladderRemarks)
    };
  }
  function getAutoApproveableStopReasons(ladderRemarks) {
    var stopReasons = [];
    if (_.isUndefined(ladderRemarks) || _.isUndefined(ladderRemarks.dataComparisonReasons)) {
      return stopReasons;
    }
    var messageThresholdCount = 10;
    var addMoreIndicator = false;
    var dataComparisonReasons = faresOptimizerDataTransformerService.getDataComparisonReasons(ladderRemarks.dataComparisonReasons, true);
    if (messageThresholdCount < dataComparisonReasons.length) {
      addMoreIndicator = true;
    } else {
      messageThresholdCount = dataComparisonReasons.length;
    }
    for (var i = 0; i < messageThresholdCount; i++) {
      stopReasons.push({
        main: dataComparisonReasons[i].header
      });
    }
    if (addMoreIndicator) {
      stopReasons.push({
        main: faresOptimizerConstants.MORE_CONTENT_INDICATOR
      });
    }
    return stopReasons;
  }
  var renderRecommendationStatusToolTip = function renderRecommendationStatusToolTip(toolTipData) {
    return recommendationStatusToolTipTemplate(toolTipData);
  };
  var shouldRenderRecommendationStatusToolTip = function shouldRenderRecommendationStatusToolTip(row) {
    return row.displayStatus === faresOptimizerConstants.NEW && (row.isRecommendationCapped || row.isAutoApprovable === false);
  };
  return {
    getRecommendedFareTooltipContent: getRecommendedFareTooltipContent,
    getRecommendedFareTooltipData: getRecommendedFareTooltipData,
    getCompetitorFareTooltipData: getCompetitorFareTooltipData,
    getEffectiveFareTooltipContent: getEffectiveFareTooltipContent,
    getRecommendedFareTooltipDataWithFbc: getRecommendedFareTooltipDataWithFbc,
    getEffectiveFareTooltipDataWithFbc: getEffectiveFareTooltipDataWithFbc,
    renderFareTooltip: renderFareTooltip,
    renderFareTooltipWithSharedFbc: renderFareTooltipWithSharedFbc,
    getHostFareBrandDescriptionContent: getHostFareBrandDescriptionContent,
    getCompFareBrandDescriptionContent: getCompFareBrandDescriptionContent,
    shouldRenderHostFareBrandDescriptionToolTip: shouldRenderHostFareBrandDescriptionToolTip,
    shouldRenderCompFareBrandDescriptionToolTip: shouldRenderCompFareBrandDescriptionToolTip,
    getNormalizedTotalFareTooltipContent: getNormalizedTotalFareTooltipContent,
    shouldRenderNormalizedTotalFareTooltip: shouldRenderNormalizedTotalFareTooltip,
    getFbcToolTip: getFbcToolTip,
    getEntryLevelFbcToolTip: getEntryLevelFbcToolTip,
    shouldRenderFbcToolTip: shouldRenderFbcToolTip,
    shouldRenderCompFareToolTip: shouldRenderCompFareToolTip,
    getCompetitorFareTooltipContent: getCompetitorFareTooltipContent,
    getWebFareTooltipData: getWebFareTooltipData,
    getWebFareTooltipContent: getWebFareTooltipContent,
    getRecommendationStatusToolTipContent: getRecommendationStatusToolTipContent,
    shouldRenderRecommendationStatusToolTip: shouldRenderRecommendationStatusToolTip
  };
};
FaresOptimizerFareTooltipService.$inject = ['$filter', 'FaresOptimizerConstants', 'FaresOptimizerDataTransformerService'];
module.exports = FaresOptimizerFareTooltipService;